// extracted by mini-css-extract-plugin
export default {"advertTabs":"_7xke-2Sc"};